module.exports = __webpack_public_path__ + "img/main-logo.8c2b15db.png";